import { Injectable } from "@angular/core";
import { DashboardService } from "../dashboard.service";
import { CommonService } from "../common.service";
import { appSettings, errorMessages } from "../../settings";
import * as moment from "moment";
import {
  SignalRConnection,
  BroadcastEventListener,
  ConnectionStatus,
  ConnectionStatuses
} from "ng2-signalr";
import { UserPreference } from "../../models/UserPreference";

@Injectable()
export class StorewaveprogressionService {
  private hub: SignalRConnection;
  labelSetting = {
    normal: {
      show: true,
      position: "outside",
      offset: [10, 0],
      textStyle: {
        fontSize: 18,
        fontFamily: "lato",
        color: "#ccc"
      }
    }
  };

  constructor(
    private _dashboardService: DashboardService,
    private _commonService: CommonService
  ) {}

  chartOptions() {
    return {
      legend: {
        data: ["Pending", "Shipped"],
        textStyle: {
          color: "#999"
        }
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow"
        }
      },
      grid: {
        containLabel: true,
        left: 20,
        right: 100
      },
      yAxis: {
        data: ["Orders", "Quantity"],
        inverse: true,
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: {
          margin: 30,
          textStyle: {
            fontSize: 14,
            color: "#ccc"
          }
        },
        axisPointer: {
          label: {
            show: true,
            margin: 30
          }
        }
      },
      xAxis: {
        splitLine: { show: false },
        axisLabel: { show: false },
        axisTick: { show: false },
        axisLine: { show: false }
      },
      color: ["#c7b299", "#29abe2"],
      series: [
        {
          name: "Pending",
          type: "pictorialBar",
          label: this.labelSetting,
          symbolRepeat: true,
          symbolSize: ["80%", "60%"],
          barCategoryGap: "20%",
          data: []
        },
        {
          name: "Shipped",
          type: "pictorialBar",
          barGap: "10%",
          label: this.labelSetting,
          symbolRepeat: true,
          symbolSize: ["60%", "60%"],
          data: []
        }
      ]
    };
  }

  init(widget: any) {
    console.log("Store Wave Progression");
    widget.dataLoaded = false;
    let currentDateTime = moment()
      .toDate()
      .getTime();
    widget.Title = "Store Wave Progression";
    widget.initcreationtime = currentDateTime;
    widget.widgetcreationtime = currentDateTime;
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.hub
      .start()
      .then(() => {
        console.log("Connection started!");
        widget.ConnectionId = widget.hub.id;
        let userPref: UserPreference = this._commonService.getUserPreference();
        widget.hub.listenFor("broadcastWaveProgression").subscribe(
          (result: any) => {
            console.log("broadcastWaveProgression", result);
            widget.dataLoaded = false;
            if (
              //result.WaveType == "Storewaveprogression" &&
              result.widgetid == widget.widgetId &&
              result.widgetcreationtime == widget.widgetcreationtime
            ) {
              widget.chartOptions = this.chartOptions();
              widget.errorMessage = null;
              //need to format this
              let Series1 = [];
              let Series2 = [];

              Series1 = [
                {
                  value: result.PendingOrderCount, //PendingQtyShip,
                  symbol: appSettings.openBox
                },
                {
                  value: result.PendingQtyOrder,
                  symbol: appSettings.units_openBox
                }
              ];

              Series2 = [
                {
                  value: result.PickedOrderCount, //ShippedQtyShip,
                  symbol: appSettings.closedBox
                },
                {
                  value: result.ShippedQtyOrder,
                  symbol: appSettings.orders_closedBox
                }
              ];

              widget.IfNoDataFound = result.IsNoDataFound;
              if (widget.IfNoDataFound) {
                widget.errorMessage = errorMessages.noWidgetData;
              }
              else {
                widget.errorMessage = null;
              }
              widget.chartOptions.series[0].data = Series1;
              widget.chartOptions.series[1].data = Series2;
            }

            //console.log(result)  ;
            widget.dataLoaded = true;
            this._commonService.lastUpdatedTime = result.LastUpdateTime;
          },
          err => {
            console.log("listenFor broadcastWaveProgression error", err);
          }
        );

        let widgetData: any = {};
        widgetData = this._commonService.deepClone(widget.widgetsettings);
        widgetData.WidgetType = "Storewaveprogression";
        widgetData.CreatedTime = widget.widgetcreationtime;
        widgetData.CustomerId = userPref.CustomerId;
        widgetData.Facility = userPref.FacilityId;
        widgetData.LastUpdate = "31-Jan-2017";
        widgetData.WidgetId = widget.widgetId;

        widgetData.ConnectionId = widget.hub.id;
        widget.hub
          .invoke("GetWidgetData", widgetData)
          .then(data => {
            //console.log('GetWidgetData', data);
          })
          .catch(err => {
            console.log("Error GetWidgetData", err);
          });
      })
      .catch(err => {
        console.log("Error while establishing connection", err);
      });
  }

  reload(widget: any) {
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.chartOptions = this.chartOptions();

    widget.hub
      .start()
      .then(() => {
        console.log("Connection started!");
        let widgetSettingParam = {
          WidgetType: "Storewaveprogression",
          WidgetId: widget.widgetId,
          CreatedTime: widget.widgetcreationtime,
          ConnectionId: widget.ConnectionId
        };
        //console.log(widgetSettingParam);
        widget.hub
          .invoke("RemoveWidget", widgetSettingParam)
          .then((isWidgetConnected: any) => {
            if (isWidgetConnected) {
            }
          });

        let oldwidgettime = widget.widgetcreationtime;
        let currentDateTime = moment()
          .toDate()
          .getTime();
        widget.widgetcreationtime = currentDateTime;

        let userPref: UserPreference = this._commonService.getUserPreference();

        let widgetData: any = {};
        widgetData = this._commonService.deepClone(widget.widgetsettings);
        widgetData.WidgetType = "Storewaveprogression";
        widgetData.CreatedTime = widget.widgetcreationtime;
        widgetData.CustomerId = userPref.CustomerId;
        widgetData.Facility = userPref.FacilityId;
        widgetData.LastUpdate = "31-Jan-2017";
        widgetData.WidgetId = widget.widgetId;
        widgetData.ConnectionId = widget.hub.id;
        widgetData.OldWidgettime = oldwidgettime;

        widget.hub
          .invoke("GetWidgetData", widgetData)
          .then(data => {
            //console.log('GetWidgetData', data);
          })
          .catch(err => {
            console.log("Error GetWidgetData", err);
          });
      })
      .catch(err => {
        console.log("Error while establishing connection", err);
      });
  }

  remove(widget: any) {
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.hub
      .start()
      .then(() => {
        let oldwidgettime = widget.widgetcreationtime;
        let widgetSettingParam = {
          WidgetType: "Storewaveprogression",
          WidgetId: widget.widgetId,
          CreatedTime: oldwidgettime,
          ConnectionId: widget.ConnectionId
        };
        let currentDateTime = moment()
          .toDate()
          .getTime();
        widget.widgetcreationtime = currentDateTime;

        widget.hub
          .invoke("RemoveWidget", widgetSettingParam)
          .then((isWidgetConnected: any) => {
            if (isWidgetConnected) {
            }
            console.log("deleteWidget Storewaveprogression RemoveWidget");
          });
      })
      .catch(err => {
        console.log("Error while establishing connection", err);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/widgets/storewaveprogression.service.ts